export default __webpack_public_path__ + "static/media/X-white.12c3620b.svg";